import { ProductPreview } from "../components/products/ProductPreview.js";
import { CallToAction } from "../components/common/CallToAction.js";
import { siteLinks } from "../data/site.js";

/** @typedef {import("../data/products.js").Product} Product */

/** @param {Product} product */
export function ProductPage(product) {
  return `
    <main id="contenido" class="product-page">
      <section class="product-hero">
        <div class="site-container product-hero-grid">
          <div class="product-hero-copy">
            <a class="back-link" href="/#productos" data-route><span aria-hidden="true">←</span> Todos los productos</a>
            <span class="eyebrow">${product.category}</span>
            <h1>${product.name}</h1>
            <p class="product-direct-answer"><strong>${product.directAnswer}</strong></p>
            <p>${product.description}</p>
            <div class="product-hero-actions">
              <a class="button button-primary" href="${siteLinks.requestDemo}">Solicitar demostración</a>
            </div>
          </div>
          ${ProductPreview({ product, className: "product-page-preview" })}
        </div>
      </section>

      <section class="section-pad bg-white" aria-labelledby="summary-title">
        <div class="site-container">
          <div class="preview-section-heading"><div><span class="eyebrow">Resumen del producto</span><h2 id="summary-title" class="section-title">Qué es, para quién es y qué cubre.</h2></div></div>
          <div class="product-table-wrap">
            <table class="product-summary-table">
              <caption>Ficha funcional de ${product.name}</caption>
              <tbody>
                <tr><th scope="row">Producto</th><td>${product.name}</td></tr>
                <tr><th scope="row">Categoría</th><td>${product.applicationSubCategory}</td></tr>
                <tr><th scope="row">Qué resuelve</th><td>${product.shortDescription}</td></tr>
                <tr><th scope="row">Funcionalidades</th><td>${product.features.join(", ")}.</td></tr>
                <tr><th scope="row">Ideal para</th><td>${product.idealFor}</td></tr>
                <tr><th scope="row">Plataformas</th><td>${product.operatingSystems.join(", ")}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section class="section-pad bg-white" aria-labelledby="problems-title">
        <div class="site-container product-details-grid">
          <div>
            <span class="eyebrow">Problemas que resuelve</span>
            <h2 id="problems-title" class="section-title">Más control sobre un proceso crítico.</h2>
          </div>
          <ul class="problem-list">${product.problems.map((problem, index) => `<li><span>0${index + 1}</span><p>${problem}</p></li>`).join("")}</ul>
        </div>
      </section>

      <section class="section-pad product-features-section" aria-labelledby="features-title">
        <div class="site-container">
          <div class="product-features-heading">
            <div><span class="eyebrow">Funcionalidades principales</span><h2 id="features-title" class="section-title">Una base preparada para tu operación.</h2></div>
          </div>
          <div class="feature-grid">${product.features.map((feature, index) => `<article><span>${String(index + 1).padStart(2, "0")}</span><h3>${feature}</h3></article>`).join("")}</div>
        </div>
      </section>

      <section class="section-pad bg-white" aria-labelledby="preview-title">
        <div class="site-container">
          <div class="preview-section-heading"><div><span class="eyebrow">Vista del producto</span><h2 id="preview-title" class="section-title">Interfaz empresarial, clara y enfocada.</h2></div></div>
          ${ProductPreview({ product, className: "product-wide-preview" })}
        </div>
      </section>

      <section class="section-pad product-faq-section" aria-labelledby="faq-title">
        <div class="site-container product-details-grid">
          <div><span class="eyebrow">Preguntas frecuentes</span><h2 id="faq-title" class="section-title">Respuestas directas sobre ${product.name}.</h2></div>
          <div class="product-faq-list">${product.faq.map(({ question, answer, answerHtml }) => `<article><h3>${question}</h3><p>${answerHtml ?? answer}</p></article>`).join("")}</div>
        </div>
      </section>

      ${CallToAction({ compact: true })}
    </main>
  `;
}
